<template>
  <div class="container">
    <Loading v-if="!requested" />
    <NavUser />
    <!-- 优惠券 -->
    <couponPopup v-if="requested && couponPopupStatus" />
    <!-- 头部导航 -->
    <TopNavbar :title="storeInfo.title" :bgColor="'bgRed'" />
    <!-- 广告轮播图 -->
    <banners v-if="requested" :arrSlides="arrSlides" :tablesInfo="tablesInfo" @evtShowStore="settingPopupStore" />
    <div style="display:none;">
      <div style="padding:10px;" @click="page404Fun">>>>TestPage Notice</div>
    </div>
    <div v-if="requested" class="main" ref="main">
      <!-- 产品列表 -->
      <van-tabs v-model="tabsActive" scrollspy sticky :offset-top="35" :ellipsis="false" :swipe-threshold="3" :style="'padding-bottom:100px;'">
        <van-tab v-for="product in productList.todoTab" :key="product.key" :title="product.text">
          <div style="padding-bottom:30px;">
            <GoodsItems :itemTitle="product.text" :itemsList="product.items" @evtShowPopup="showPopup" />
          </div>
        </van-tab>
      </van-tabs>
      <!-- 属性规格窗口底部 -->
      <div v-if="show" class="attr-bottom">
        <div ref="posBottom" class="pos-bottom">
          <div class="select-quanity">
            <van-stepper v-model="qty" disabled-input="true" input-width="40px" button-size="40px" @minus="getCurrentAttrTotal" @plus="getCurrentAttrTotal" />
          </div>
          <div class="goods-inventory" v-if="currentGood.counts>=1">Stock Quantity: {{currentGood.counts}} {{currentGood.unitname}}</div>
          <div class="confirm-btn" :class="{'btn-on-bg':isRequired, 'btn-off-bg':!isRequired, 'no-more-item':(parseInt(currentGood.counts)>=1 && parseInt(qty) > parseInt(currentGood.counts))}" @click="addToCart">CONFIRM - {{ currentAttrTotal }}</div>
        </div>
      </div>
      <!-- 属性规格窗口内容区 -->
      <van-popup v-model="show" position="bottom" class="attr-wapper" :style="{ height: attrPopupHeight, background:'#ffffff' }">
        <GoodsAttr v-if="show" :attrList="currentGood.goods_attr_list" :goods="currentGood" @evtClosePopup="closePopup" @evtChooseAttr0="chooseAttr" @evtIsRequired="setIsRequired" />
      </van-popup>
      <!-- 商铺信息窗口 -->
      <van-popup :key="popupStoreKey" v-model="popupStore" position="top" :class="'store-info'" :style="{ width: '100%' }">
        <storeInfo :store-info="storeInfo" @evtCloseMyStore="closeMyStore" />
      </van-popup>
    </div>
    <shoppingCart v-if="requested" />
    <Footer v-if="requested" @evtCompleteOrder="completeOrder" />
  </div>
</template>

<script>
import TopNavbar from "../../components/common/TopNavbar.vue";
import NavUser from "../../components/common/NavUser.vue";
import Footer from "../../components/common/Footer.vue";
import GoodsItems from "../../components/common/GoodsItems.vue";
import GoodsAttr from "../../components/common/GoodsAttr.vue";
import Loading from "../../components/common/Loading.vue";
import storeInfo from "./myStore.vue";
import banners from "./banners.vue";
import shoppingCart from "./shoppingCart";
import couponPopup from "./coupon";
import { indexPage, updateDishnumOfCategory } from "@/api/api";
import mockDemo from "@/api/mock";
import { cartMixin } from "@/mixins/cartMixin";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "index",
  components: {
    TopNavbar,
    Footer,
    GoodsItems,
    GoodsAttr,
    banners,
    Loading,
    storeInfo,
    shoppingCart,
    couponPopup,
    NavUser
  },
  data () {
    return {
      requested: false,
      is_weixin: false,
      //弹出获取优惠券窗口，输入手机号码获取
      couponPopupStatus: false,
      arrSlides: [],
      storeInfo: {},
      //弹出商家基础信息，半透明窗口
      popupStore: false,
      popupStoreKey: +(new Date()),
      //桌子信息
      tablesInfo: {
        // title:'',
        // promo:''
      },

      is_sticky: false,
      tabsActive: 0,
      startSku: 1000,
      productList: {},
      isRequired: false, //true所有的必选项都已经符合条件， 反之不符合条件，则不能提交确认和修改数据

      //浮动窗口显示状态
      show: false,
      //点击后弹窗展示被点击商品的商品所有的信息
      currentGood: null,
      qty: 0,
      //当前选中的属性
      currentAttr: null,
      //是否已经选择规格或者属性选项
      isSelectedAttr: false,
      currentAttrTotal: 0.0,
      attrPopupHeight: "100%",
      //添加到购物车前的商品和商品属性
      preGoods: [],

      // 显示购物车窗口
      showShoppingCart: false,
      isTakeaway: false,
      isDelivery: false,
    };
  },
  mixins: [cartMixin],
  mounted () {
    // setTimeout(this.setTabsPosTop, 100)
  },
  created () {
    this.get_data();
    this.is_weixin = this.isOnWeixin();
  },
  computed: {
    ...mapGetters(["cart_qty", "cart_subtotal", "user_islogin", "user_detail"])
  },
  methods: {
    ...mapActions({
      initShopingCart: "shoppping_cart/resetShoppingCart",
      settingGoodsList: "shoppping_cart/settingGoodsList",
      resetCart: "shoppping_cart/resetShoppingCart",
      settingQty: "shoppping_cart/settingQty",
      settingSubtotal: "shoppping_cart/settingSubtotal",
      setRadioAddons: "shoppping_cart/settingRadioGoodsAddons",
      settingStoreInfo: "shoppping_cart/settingStoreInfo",
      settingAttrRadio: "shoppping_cart/setAttrRadio"
    }),

    settingPopupStore(){
      this.popupStoreKey = + +(new Date())
      this.popupStore=true
    },

    setIsRequired (isRequired) {
      this.isRequired = isRequired;
    },
    getCurrentAttrTotal () {
      //获取和计算属性规格的价格信息
      setTimeout(() => {
        let attr_total = 0.0;
        if (this.currentGood) {
          attr_total = parseFloat(this.currentGood.marketprice);
        }
        this.currentAttr &&
          this.currentAttr.length &&
          this.currentAttr.forEach(priceItem => {
            attr_total = attr_total + parseFloat(priceItem.price);
          });
        this.currentAttrTotal = this.fmPrice(attr_total * this.qty);
      }, 10);
    },
    showPopup (curGoods) {
      this.qty = 1;
      const filterAttr = () => {
        let tmpRadios = {};
        if (curGoods.goods_attr_list.length) {
          curGoods.goods_attr_list.forEach(attr_item => {
            tmpRadios[attr_item.title] =
              attr_item.items[0].is_multiple == 1 ? [] : "";
          });
        }
        return tmpRadios;
      };
      this.currentGood = null;
      this.currentAttr = null;
      this.currentGood = curGoods;
      this.setRadioAddons(filterAttr()); //设置默认选中的规格
      this.settingAttrRadio({
        attr_list: this.currentGood["goods_attr_list"],
        choosed: false
      });

      this.show = true;
      this.isSelectedAttr = false;
      this.attrPopupHeight = "100%";
      if (curGoods.goods_attr_list.length == 0) {
        this.isSelectedAttr = true;
        this.currentAttr = { sku: curGoods.sku, attr: {} };
        // this.attrPopupHeight = '40%';
      }
      setTimeout(() => {
        this.getCurrentAttrTotal();
      }, 10);
    },
    setTabsPosTop () {
      //Tabs的吸顶功能生效
      this.is_sticky = true;
      this.tabsActive = 0;
    },
    closePopup () {
      //关闭选择菜名的属性窗口
      this.show = false;
    },
    chooseAttr (attrOptions) {
      // console.log('index.attrOptions=======>', attrOptions);
      // 当前菜的被选中的属性信息
      this.currentAttr = attrOptions.attr || null;
      this.isSelectedAttr = true;
      setTimeout(() => {
        this.getCurrentAttrTotal();
      }, 10);
    },
    addToCart () {
      let is_inventory =
        parseInt(this.currentGood.counts) >= 1 &&
          parseInt(this.qty) <= parseInt(this.currentGood.counts)
          ? true
          : false;
      if (parseInt(this.currentGood.counts) == -1) {
        is_inventory = true;
      }
      if (is_inventory) {
        if (this.isRequired == false) {
          this.$toast("the require option can not empty");
        } else {
          // 是否选择了规格
          const isChoosed = this.currentAttr ? true : false;
          const attr1 = {
            sky: this.currentGood.sky,
            sku: this.currentGood.sku,
            goodsid: this.currentGood.id,
            price: this.currentGood.marketprice,
            options: isChoosed ? this.currentAttr : 0,
            qty: this.qty,
            optionname: isChoosed ? this.getOptionName(this.currentAttr) : 0,
            optionid: isChoosed ? this.getOptionId(this.currentAttr) : ""
          };
          const objQuery = this.getUrlParams({ do: "UpdateDishNumOfCategory" });
          const updateOption = () => {
            const queryParams = Object.assign(objQuery, {
              optype: "add",
              o2uNum: attr1.qty,
              optionid: attr1.optionid,
              dishid: attr1.goodsid,
              cart_id: 0
            });
            // console.log('添加到购物车.queryParams', queryParams);
            updateDishnumOfCategory("/app/index.php", queryParams)
              .then(res => {
                const apiResData = {
                  totalprice: res.message.totalprice,
                  totalcount: res.message.totalcount,
                  cart: res.message.cartList,
                  products: false
                };
                if (parseInt(res.message.code) == 200) {
                  this.resetCart(apiResData);
                } else {
                  this.$toast(res.message.msg);
                }
              })
              .catch(error => {
                // console.log('添加到购物车.error', error);
              });
          };
          updateOption && updateOption();
          this.closePopup();
        }
      } else {
        // console.log('数量超出太多了');
      }
    },
    cleanShoppingCart () {
      // 清除购物车并关闭窗口
      this.preGoods = [];
      this.showShoppingCart = false;
    },
    closeMyStore () {
      //关闭店铺的弹窗
      this.popupStore = false;
    },
    toggleShoppingCart (new_status) {
      // 是否显示购物车内容
      this.showShoppingCart = new_status;
    },
    completeOrder () {
      if (this.cart_qty < 1) {
        this.$toast("Your cart is empty!");
      } else {
        let url = {
          path: "/cart",
          query: this.getUrlParams({ do: "wapmenu" })
        };
        if (this.isDelivery) {
          url.path = '/delivery'
        }
        if (this.isTakeaway) {
          url.path = '/takeaway'
        }
        this.$router.push(url);
      }
    },

    get_data () {
      const queryParams = this.getUrlParams({ do: "waplist" });
      //轮播图数据处理
      const resSlides = indexpage => {
        let isSlide = false;
        const mapSlides =
          indexpage.waplist.thumbs &&
          indexpage.waplist.thumbs.map(item => {
            if (item.slide_src) {
              isSlide = true;
            }
            return item.slide_src;
          });
        if (isSlide == false) {
          return [];
        }
        return this.array_unique(mapSlides);
      };
      //处理返回来的数据
      const todo = indexpage => {
        //轮播图
        this.arrSlides = resSlides(indexpage);

        this.storeInfo = indexpage.store;
        this.settingStoreInfo(indexpage.store);
        this.tablesInfo = {
          title: indexpage.table.title || "",
          tel: indexpage.store.tel || "",
          table: indexpage.table,
          tablezones: indexpage.tablezones,
          promo: indexpage.store.promo || ""
        };

        //分类Tab及产品列表
        const getGoodsData = arr => {
          return arr;
        };

        let str_selected = "";
        const arrTodoTab =
          indexpage.category &&
          indexpage.category.map(item => {
            if (str_selected == "") {
              str_selected = "tab-" + item.id;
            }
            return {
              key: "tab-" + item.id,
              text: item.name,
              items: getGoodsData(indexpage.goodslist[item.id].goods)
            };
          });

        this.productList = {
          selected: str_selected,
          todoTab: arrTodoTab
        };
      };

      if (this.isDevEnv()) {
        const indexpage = mockDemo.indexPage.data;

        this.initShopingCart(indexpage);
        todo && todo(indexpage);
        setTimeout(() => {
          this.requested = true;
          this.setTabsPosTop();
          this.couponPopupStatus = false;
        }, 100);
      } else {
        // console.log('开始请求页面数据-queryParams=>', queryParams);
        indexPage("/app/index.php", queryParams)
          .then(res => {
            const indexpage = res.data;
            if (indexpage !== undefined) {
              if (indexpage.waplist_type) {
                if (indexpage.message != "") {
                  //this.$toast(indexpage.message )
                }
                if (indexpage.waplist_type == "new_page") {
                  window.location.href = indexpage.forward_url;
                }
              } else {
                this.isTakeaway = indexpage.isTakeaway || false
                this.isDelivery = indexpage.isDelivery || false
                this.initShopingCart(indexpage);
                todo && todo(indexpage);
                setTimeout(() => {
                  this.requested = true;
                  console.log("请求结束");
                  this.couponPopupStatus = false;
                }, 300);
              }
            } else {
              if (res && res.waplist_type) {
                if (
                  res.waplist_type == "new_page" &&
                  res.forward_url &&
                  res.forward_url != ""
                ) {
                  console.log('result---------', res);
                  window.location.href = res.forward_url;
                }
              }
            }
          })
          .catch(error => {
            this.$toast("network timeout");
          });
      }
    },
    page404Fun () {
      const url = {
        path: "/googlemap",
        query: this.getUrlParams({ do: "merchant" })
      };
      console.log("========>", url);

      this.$router.push(url);
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');

.container {
  .top-wapper {
    margin: 36px 0 0 0;
    .slides {
      .slide-list {
        img {
          width: 100%;
          display: block;
        }
      }
    }
    .stores {
      background-color: rgba(0, 0, 0, 0.05);
      .call-waiter {
        background-color: rgba(0, 0, 0, 0.35);
        color: @fff;
        padding: 3px 8px;
        border-radius: 15px;
      }
    }

    .merchant-icon {
      border-radius: 50%;
      color: #fff;
      background-color: rgba(105, 105, 105, 0.5);
      position: absolute;
      top: 90px;
      right: 10px;
      padding: 8px;
    }
  }
  .bgRed {
    background-color: @red !important;
  }
  .main {
    .attr-bottom {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3002;
      box-shadow: 0px 17px 20px 10px rgba(146, 146, 146, 0.85),
        -10px 10px 10px 10px rgba(255, 255, 255, 0.5);
      .pos-bottom {
        padding: 8px;
        text-align: center;
        background-color: #ffffff;
        text-align: center;

        .select-quanity {
          text-align: center;
          font-weight: bold;
        }
        .goods-inventory {
          margin: 10px 0;
          font-size: 14px;
          color: #07c160;
        }
        .btn-on-bg {
          background-color: @red;
        }
        .btn-off-bg {
          background-color: #6b6b6b;
        }
        .no-more-item {
          background-color: #a7a7a7 !important;
        }
        .confirm-btn {
          border-radius: 5px;
          margin: 10px 5px 20px 5px;
          color: @fff;
          padding: 14px 0px;
          font-size: 18px;
        }
      }
    }
    .store-info {
      background-color: rgba(255, 255, 255, 0);
      color: #fff;
    }
  }

  .popup-loading {
    background-color: rgba(255, 255, 255, 0);
    color: #fff;
  }
}
</style>

